import { IPropertyPresentable } from "./IPropertyPresentable";

export abstract class AbstractPropertyPresenter<TSource, TValue> implements IPropertyPresentable<TValue> {
  constructor(source: TSource | AbstractPropertyPresenter<TSource, TValue>) {
    this._source = (source instanceof AbstractPropertyPresenter)
      ? source._source
      : source;
  }

  protected readonly _source: TSource;

  getValue(): TValue {
    return this.readValue(this._source);
  }

  abstract readValue(source: TSource): TValue;
}
